<template>
	<div class="userstoreTab">
		<div  class="userstoreTab_box">
            <div style="font-size:20px;padding:5px 0;">{{$t('other.a2797')}}</div>
			<el-tabs v-model="this.$route.path"  @tab-click="handleClick">
			   <el-tab-pane 
			   v-for="item in tabs"
			   :key="item.name"
			   :label="item.label"
			   :name="item.name"
			   >
			   </el-tab-pane>
			</el-tabs>	
		</div>
		<div>
			 <router-view></router-view>
		</div>
	</div>
</template>

<script>
import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default{
		data(){
			return {
				activeIndex:null,
				
				tabs: [
				  { label: this.$t('other.a2798'), name: "/alliance/singleGoods",},
				  { label: this.$t('other.a2799'), name: "/alliance/combination",}
				  
				],
			}
    },
    computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userName: state => state.shopaccess.userInfo.userName,
			
				
			}),
		},  
		created(){
			// this.init()

		},
		
		methods: {
			init(){
				this.activeIndex=this.tabs[0].name
			},
			
			handleClick(tab, event,name) {
				this.$router.push({path:tab.name})
			},
		}
		
	}
</script>

<style>
	
	.userstoreTab{
		/* flex: 1;
		margin: 60px 0 0 235px; */
		min-height: 100vh;
		background-color: #eee;
		
		
	}

	.userstoreTab .userstoreTab_box{
		
		position: absolute;
		top:0px;
		left: 0;
		z-index: 6;
		width: 100%;
		padding: 10px 10px;
		background-color: #fff;

	
	}

	.el-tabs__item{
		font-size: 18px!important;
		font-weight: bold;
	}
	
</style>
